import { datafiles } from './datafiles';
import { FeatureEnvironments, SdkKeys, FEATURES } from './enums';
import { getCurrentEnvironment, isDev, isUat, isProd } from './environment';
import Provider from './Provider';

export {
  Provider,
  FEATURES,
  FeatureEnvironments,
  SdkKeys,
  datafiles,
  getCurrentEnvironment,
  isDev,
  isUat,
  isProd,
};
